/*计算属性*/
export function calculatePercent(data,sumData,typeDate){
    let res = {};
    let total = 0;
    for(let i = 0 ; i < data.length ; i++){
        let temp = data[i];
        total += temp[sumData];
    }
    for(let i = 0 ; i < data.length ; i++){
        let temp = data[i];
        let type = temp[typeDate];
        res[type] = (temp[sumData]/total*100).toFixed(2);
    }

    return res;
}
